import { render, staticRenderFns } from "./ShareVideoForm.vue?vue&type=template&id=5c0e80b1&"
import script from "./ShareVideoForm.vue?vue&type=script&lang=js&"
export * from "./ShareVideoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports